import React from "react";
import * as actions from "../../../actions";
import { connect } from "react-redux";
import { parseFileUploadErrors } from "../../../constants/parse/organization";
import StatusMessage from "../../statusMessage/statusMessage";
import _ from "lodash";

class UploadFileErrors extends React.Component {
  state = {
    toBeRemoved: [],
  };

  toBeRemoved = (uuid) => {
    const { organizationId } = this.props;
    const { toBeRemoved } = this.state;
    setTimeout(() => {
      this.props.removeOrganizationFileUploadError({
        organizationId,
        uuid,
      });
      this.setState({
        toBeRemoved: toBeRemoved.filter((item) => item !== uuid),
      });
    }, 10000);
    this.setState({
      toBeRemoved: [...toBeRemoved, uuid],
    });
  };

  componentWillUnmount() {
    const { organizationId } = this.props;
    this.props.removeOrganizationFileUploadError({
      organizationId,
    });
  }

  render() {
    const { errors, organizationId, removeOrganizationFileUploadError } =
      this.props;
    // Handle both Immutable Map and plain object
    const errorData =
      errors && typeof errors.get === "function"
        ? errors.get(organizationId)
        : errors?.[organizationId];
    const uploadFileErrors = parseFileUploadErrors(errorData);
    const { toBeRemoved } = this.state;
    return (
      <div>
        {uploadFileErrors &&
          _.sortBy(uploadFileErrors, ["created"]).map((error) => (
            <StatusMessage
              onClose={() => {
                removeOrganizationFileUploadError({
                  organizationId,
                  uuid: error.uuid,
                });
              }}
              key={error.uuid}
              modifiers={[StatusMessage.ERROR]}
            >
              {toBeRemoved.indexOf(error.uuid) === -1
                ? this.toBeRemoved(error.uuid)
                : null}
              <div>
                <strong>{error.fileName}</strong>
              </div>
              <div>{error.detail}</div>
            </StatusMessage>
          ))}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  errors: state.organizationFormReducer?.errors,
});

const mapDispatchToProps = (dispatch) => ({
  removeOrganizationFileUploadError: (payload) => {
    dispatch(actions.removeOrganizationFileUploadError(payload));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(UploadFileErrors);
